import QRCode from "qrcode";

// Stampa ricevuta accettazione (termica 80mm) ed etichetta DYMO (57x32mm) per le riparazioni.
export const SHOP = {
  name: "ESSEDI S.r.l.",
  tagline: "Vendita e assistenza informatica",
  address: "Via Cardito 203 — 83031 Ariano Irpino (AV)",
  phone: "Tel./WhatsApp 0825 892104",
  vat: "P.IVA 02800630648",
  web: "essediariano.it",
  logo: "/logo.png",
};

const fmtDate = (d) => new Date(d).toLocaleDateString("it-IT");
const eur = (n) => `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2 })}`;
const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const openPrintWindow = (html, w, h) => {
  const win = window.open("", "_blank", `width=${w},height=${h}`);
  if (!win) return false;
  win.document.open();
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => { win.print(); }, 350);
  return true;
};

const REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJoTrZBgmJORMR4qxfZhkb0m8";

// finestra aperta in modo sincrono (gesto utente), contenuto scritto dopo la generazione del QR
const openBlankWindow = (w, h) => window.open("", "_blank", `width=${w},height=${h}`);

const writeAndPrint = (win, html) => {
  if (!win) return false;
  win.document.open();
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => { win.print(); }, 350);
  return true;
};

const reviewQr = () => QRCode.toDataURL(REVIEW_URL, { margin: 0, width: 220 });

const qrBlock = (dataUrl) => `
  <div class="rule"></div>
  <div class="qr">
    <img src="${dataUrl}" alt="QR recensione">
    <div class="cap">Inquadra e lasciaci una recensione!</div>
  </div>`;

export async function printRepairReceipt(r) {
  const win = openBlankWindow(420, 720);
  const qr = await reviewQr();
  const accessories = (r.accessories || []).length ? r.accessories.join(", ") : "Nessuno";
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Ricevuta accettazione</title>
<style>
  @page { size: 80mm auto; margin: 0; }
  * { box-sizing: border-box; }
  body { width: 66mm; margin: 0 auto; padding: 3mm 1mm 6mm; font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif; color: #000; font-size: 11px; line-height: 1.4; }
  .center { text-align: center; }
  .logo { width: 40mm; height: auto; max-height: 16mm; object-fit: contain; display: block; margin: 0 auto 2mm; }
  .shop-name { font-size: 15px; font-weight: bold; letter-spacing: 1px; }
  .small { font-size: 9.5px; }
  .rule { border-top: 1px dashed #000; margin: 2.5mm 0; }
  .title { font-size: 12.5px; font-weight: bold; text-align: center; letter-spacing: 0.5px; margin: 1mm 0; }
  .row { display: flex; justify-content: space-between; gap: 3mm; margin: 1mm 0; }
  .lbl { font-weight: bold; }
  .client-name { font-size: 14.5px; font-weight: bold; text-transform: uppercase; letter-spacing: 0.3px; }
  .client-phone { font-size: 13.5px; font-weight: bold; }
  .box { border: 1px solid #000; border-radius: 2px; padding: 2mm; margin: 2mm 0; }
  .clause { font-size: 8.5px; text-align: justify; margin-top: 2.5mm; }
  .qr { text-align: center; margin: 2mm 0 1mm; }
  .qr img { width: 22mm; height: 22mm; }
  .qr .cap { font-size: 9px; font-weight: bold; letter-spacing: 0.3px; margin-top: 1mm; }
  .sig { margin-top: 9mm; display: flex; justify-content: space-between; font-size: 9.5px; }
  .sigline { border-top: 1px solid #000; width: 30mm; padding-top: 1mm; text-align: center; }
</style></head><body>
  <div class="center">
    <img class="logo" src="${SHOP.logo}" onerror="this.style.display='none'" alt="">
    <div class="shop-name">${esc(SHOP.name)}</div>
    <div class="small" style="font-weight:bold">${esc(SHOP.tagline)}</div>
    <div class="small">${esc(SHOP.address)}</div>
    <div class="small">${esc(SHOP.phone)} — ${esc(SHOP.vat)}</div>
    <div class="small">${esc(SHOP.web)}</div>
    <div class="small" style="margin-top:1mm;letter-spacing:0.5px"><b>SPECIALISTI IN ASSISTENZA TECNICA<br>SU SMARTPHONE, TABLET E PC</b></div>
  </div>
  <div class="rule"></div>
  <div class="title">RICEVUTA DI ACCETTAZIONE<br>PER RIPARAZIONE</div>
  <div class="row"><span class="lbl">N. pratica:</span><span>${esc(String(r.id || "").slice(-8).toUpperCase())}</span></div>
  <div class="row"><span class="lbl">Data:</span><span>${fmtDate(r.created_at)}</span></div>
  <div class="rule"></div>
  <div class="row"><span class="lbl">Cliente:</span><span class="client-name">${esc(r.client_name)}</span></div>
  <div class="row"><span class="lbl">Telefono:</span><span class="client-phone">${esc(r.client_phone || "—")}</span></div>
  <div class="rule"></div>
  <div class="box">
    <div class="row"><span class="lbl">Dispositivo:</span><span>${esc(r.device_label)}</span></div>
    <div class="row"><span class="lbl">Tipo:</span><span style="text-transform:capitalize">${esc(r.device_type || "")}</span></div>
    <div class="row"><span class="lbl">Accessori:</span><span>${esc(accessories)}</span></div>
    <div class="row"><span class="lbl">Blocco:</span><span>${r.no_password ? "Senza password" : "Con password"}</span></div>
  </div>
  <div class="lbl">Problema riscontrato:</div>
  <div>${esc(r.problem)}</div>
  ${r.price != null ? `<div class="row" style="margin-top:2mm"><span class="lbl">Preventivo:</span><span class="lbl">${eur(r.price)}</span></div>` : ""}
  ${r.estimated_delivery ? `<div class="row"><span class="lbl">Consegna stimata:</span><span>${esc(r.estimated_delivery)}</span></div>` : ""}
  <div class="row"><span class="lbl">Tecnico:</span><span>${esc(r.technician_name)}</span></div>
  <div class="rule"></div>
  <div class="clause">
    Con la consegna del dispositivo il cliente accetta, anche per tacito assenso, le condizioni
    di assistenza esposte presso il punto vendita. Il dispositivo non ritirato entro 90 giorni
    dalla comunicazione di avvenuta riparazione si intenderà abbandonato.
    Documento non valido ai fini fiscali.
  </div>
  ${qrBlock(qr)}
  <div class="rule"></div>
  <div class="center small" style="font-weight:bold">Grazie per averci scelto — la tua tecnologia è in buone mani!</div>
</body></html>`;
  return writeAndPrint(win, html);
}

export async function printOrderReceipt(o) {
  const win = openBlankWindow(420, 720);
  const qr = await reviewQr();
  const remaining = o.price != null && o.deposit != null ? Math.max(0, o.price - o.deposit) : null;
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Ricevuta ordine</title>
<style>
  @page { size: 80mm auto; margin: 0; }
  * { box-sizing: border-box; }
  body { width: 66mm; margin: 0 auto; padding: 3mm 1mm 6mm; font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif; color: #000; font-size: 11px; line-height: 1.4; }
  .center { text-align: center; }
  .logo { width: 40mm; height: auto; max-height: 16mm; object-fit: contain; display: block; margin: 0 auto 2mm; }
  .shop-name { font-size: 15px; font-weight: bold; letter-spacing: 1px; }
  .small { font-size: 9.5px; }
  .rule { border-top: 1px dashed #000; margin: 2.5mm 0; }
  .title { font-size: 12.5px; font-weight: bold; text-align: center; letter-spacing: 0.5px; margin: 1mm 0; }
  .row { display: flex; justify-content: space-between; gap: 3mm; margin: 1mm 0; }
  .lbl { font-weight: bold; }
  .client-name { font-size: 15px; font-weight: bold; text-transform: uppercase; letter-spacing: 0.3px; }
  .client-phone { font-size: 13.5px; font-weight: bold; }
  .box { border: 1px solid #000; border-radius: 2px; padding: 2mm; margin: 2mm 0; }
  .qr { text-align: center; margin: 2mm 0 1mm; }
  .qr img { width: 22mm; height: 22mm; }
  .qr .cap { font-size: 9px; font-weight: bold; letter-spacing: 0.3px; margin-top: 1mm; }
  .big { font-size: 13px; }
  .clause { font-size: 8.5px; text-align: justify; margin-top: 2.5mm; }
</style></head><body>
  <div class="center">
    <img class="logo" src="${SHOP.logo}" onerror="this.style.display='none'" alt="">
    <div class="shop-name">${esc(SHOP.name)}</div>
    <div class="small" style="font-weight:bold">${esc(SHOP.tagline)}</div>
    <div class="small">${esc(SHOP.address)}</div>
    <div class="small">${esc(SHOP.phone)} — ${esc(SHOP.vat)}</div>
    <div class="small">${esc(SHOP.web)}</div>
  </div>
  <div class="rule"></div>
  <div class="title">RICEVUTA ORDINE<br>RICAMBIO / ACCESSORIO</div>
  <div class="row"><span class="lbl">N. ordine:</span><span>${esc(String(o.id || "").slice(-8).toUpperCase())}</span></div>
  <div class="row"><span class="lbl">Data:</span><span>${fmtDate(o.created_at)}</span></div>
  <div class="rule"></div>
  <div class="row"><span class="lbl">Cliente:</span><span class="client-name">${esc(o.client_name)}</span></div>
  <div class="row"><span class="lbl">Telefono:</span><span class="client-phone">${esc(o.client_phone || "—")}</span></div>
  <div class="rule"></div>
  <div class="lbl">Articolo ordinato:</div>
  <div>${esc(o.article)}</div>
  ${o.notes ? `<div class="small" style="margin-top:1mm">Note: ${esc(o.notes)}</div>` : ""}
  <div class="box" style="margin-top:2.5mm">
    <div class="row"><span class="lbl">Costo totale:</span><span class="lbl">${o.price != null ? eur(o.price) : "Da definire"}</span></div>
    <div class="row"><span class="lbl">Acconto cliente:</span><span class="lbl">${eur(o.deposit)}</span></div>
    ${remaining != null ? `<div class="row big" style="border-top:1px solid #000;padding-top:1.5mm;margin-top:1.5mm"><span class="lbl">SOMMA RESTANTE:</span><span class="lbl">${eur(remaining)}</span></div>` : ""}
  </div>
  <div class="row"><span class="lbl">Registrato da:</span><span>${esc(o.created_by || "")}</span></div>
  <div class="rule"></div>
  <div class="clause">
    La presente ricevuta attesta l'ordine del ricambio/accessorio indicato e l'eventuale acconto versato.
    Il cliente sarà avvisato telefonicamente o tramite WhatsApp all'arrivo della merce.
    Documento non valido ai fini fiscali.
  </div>
  ${qrBlock(qr)}
  <div class="rule"></div>
  <div class="center small" style="font-weight:bold">Grazie per averci scelto — la tua tecnologia è in buone mani!</div>
</body></html>`;
  return writeAndPrint(win, html);
}

export async function printRepairClosure(r) {
  const win = openBlankWindow(420, 720);
  const qr = await reviewQr();
  const accessories = (r.accessories || []).length ? r.accessories.join(", ") : "Nessuno";
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Foglio di chiusura</title>
<style>
  @page { size: 80mm auto; margin: 0; }
  * { box-sizing: border-box; }
  body { width: 66mm; margin: 0 auto; padding: 3mm 1mm 6mm; font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif; color: #000; font-size: 11px; line-height: 1.4; }
  .center { text-align: center; }
  .logo { width: 40mm; height: auto; max-height: 16mm; object-fit: contain; display: block; margin: 0 auto 2mm; }
  .shop-name { font-size: 15px; font-weight: bold; letter-spacing: 1px; }
  .small { font-size: 9.5px; }
  .rule { border-top: 1px dashed #000; margin: 2.5mm 0; }
  .title { font-size: 12.5px; font-weight: bold; text-align: center; letter-spacing: 0.5px; margin: 1mm 0; }
  .row { display: flex; justify-content: space-between; gap: 3mm; margin: 1mm 0; }
  .lbl { font-weight: bold; }
  .client-name { font-size: 14.5px; font-weight: bold; text-transform: uppercase; letter-spacing: 0.3px; }
  .client-phone { font-size: 13.5px; font-weight: bold; }
  .box { border: 1px solid #000; border-radius: 2px; padding: 2mm; margin: 2mm 0; }
  .qr { text-align: center; margin: 2mm 0 1mm; }
  .qr img { width: 22mm; height: 22mm; }
  .qr .cap { font-size: 9px; font-weight: bold; letter-spacing: 0.3px; margin-top: 1mm; }
  .bigbox { border: 2px solid #000; border-radius: 3px; padding: 2.5mm; margin: 3mm 0 0; }
  .work-lbl { font-size: 10px; font-weight: bold; letter-spacing: 1px; margin-bottom: 1mm; }
  .work { font-size: 12.5px; font-weight: bold; }
  .pricebox { text-align: center; margin-top: 2.5mm; }
  .pricebox .pl { font-size: 10px; letter-spacing: 1.5px; color: #000; }
  .pricebox .pv { font-size: 19px; font-weight: bold; margin-top: 0.5mm; color: #000; }
  .clause { font-size: 8.5px; text-align: center; margin-top: 2.5mm; }
</style></head><body>
  <div class="center">
    <img class="logo" src="${SHOP.logo}" onerror="this.style.display='none'" alt="">
    <div class="shop-name">${esc(SHOP.name)}</div>
    <div class="small" style="font-weight:bold">${esc(SHOP.tagline)}</div>
    <div class="small">${esc(SHOP.address)}</div>
    <div class="small">${esc(SHOP.phone)} — ${esc(SHOP.vat)}</div>
    <div class="small">${esc(SHOP.web)}</div>
  </div>
  <div class="rule"></div>
  <div class="title">FOGLIO DI CHIUSURA<br>RIPARAZIONE</div>
  <div class="row"><span class="lbl">N. pratica:</span><span>${esc(String(r.id || "").slice(-8).toUpperCase())}</span></div>
  <div class="row"><span class="lbl">Ricevuto il:</span><span>${fmtDate(r.created_at)}</span></div>
  <div class="row"><span class="lbl">Chiuso il:</span><span>${fmtDate(r.completed_at || r.created_at)}</span></div>
  <div class="rule"></div>
  <div class="row"><span class="lbl">Cliente:</span><span class="client-name">${esc(r.client_name)}</span></div>
  <div class="row"><span class="lbl">Telefono:</span><span class="client-phone">${esc(r.client_phone || "—")}</span></div>
  <div class="rule"></div>
  <div class="box">
    <div class="row"><span class="lbl">Dispositivo:</span><span>${esc(r.device_label)}</span></div>
    <div class="row"><span class="lbl">Tipo:</span><span style="text-transform:capitalize">${esc(r.device_type || "")}</span></div>
    <div class="row"><span class="lbl">Accessori:</span><span>${esc(accessories)}</span></div>
  </div>
  <div class="lbl">Problema riscontrato:</div>
  <div>${esc(r.problem)}</div>
  <div class="bigbox">
    <div class="work-lbl">LAVORO ESEGUITO</div>
    <div class="work">${esc(r.resolution || "—")}</div>
  </div>
  ${r.price != null ? `<div class="pricebox"><div class="pl">IMPORTO DA PAGARE</div><div class="pv">${eur(r.price)}</div></div>` : ""}
  <div class="rule"></div>
  <div class="clause">Documento non valido ai fini fiscali.</div>
  ${qrBlock(qr)}
  <div class="rule"></div>
  <div class="center small" style="font-weight:bold; margin-top:1.5mm">Grazie per averci scelto —<br>la tua tecnologia è in buone mani!</div>
</body></html>`;
  return writeAndPrint(win, html);
}

export function printRepairLabel(r) {
  const problem = String(r.problem || "").slice(0, 90);
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Etichetta</title>
<style>
  @page { size: 57mm 32mm; margin: 0; }
  * { box-sizing: border-box; }
  body { width: 57mm; height: 32mm; margin: 0; padding: 2mm 2.5mm; font-family: Arial, sans-serif; color: #000; overflow: hidden; display: flex; flex-direction: column; justify-content: space-evenly; }
  .name { font-size: 10.5px; font-weight: bold; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .line { font-size: 9px; line-height: 1.35; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .prob { font-size: 8.5px; line-height: 1.3; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
  .foot { display: flex; justify-content: space-between; font-size: 8.5px; border-top: 1px solid #000; padding-top: 1mm; }
</style></head><body>
  <div class="name">${esc(r.client_name)}</div>
  <div class="line">Tel: ${esc(r.client_phone || "—")}</div>
  <div class="line"><b>${r.no_password ? "Senza password" : `Pwd: ${esc(r.unlock_password || "—")}`}</b> — ${esc(r.device_label)}</div>
  <div class="prob">${esc(problem)}</div>
  <div class="foot"><span>Ricevuto: ${fmtDate(r.created_at)}</span><span>${esc(String(r.id || "").slice(-6).toUpperCase())}</span></div>
</body></html>`;
  return openPrintWindow(html, 320, 260);
}
